import React from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';

/**
 * FunctionDashboard - グラフベースダッシュボードページ
 * 
 * 437行 → 15行に圧縮（DashboardLayout共通化により）
 */
function FunctionDashboard() {
    return (
        <DashboardLayout
            variant="function"
            seoProps={{
                title: '人通りデータ | 高山市AIカメラデータ',
                description: '高山市のAIカメラから取得した歩行者オープンデータを活用。様々な分析機能とビジュアライゼーションツールで混雑状況を詳細に分析できます。',
                keywords: '高山市,ダッシュボード,観光,混雑度,混雑状況,データ可視化,オープンデータ,データ分析,グラフベース,分析ツール,飛騨高山,MDG,遠藤・浦田研究室',
                url: 'https://ai-camera.lab.mdg-meidai.com/function',
            }}
        />
    );
}

export default FunctionDashboard;
